import React from 'react'
import CommonBanner from './../../common/CommonBanner';
import { assets } from '../../../Assets/assets';
import LabelHeading from '../../common/LabelHeading';
import { Link } from 'react-router-dom';

const AboutHero = ({ id }) => {

  const labelData = [
    {
      icon: assets.abouticon1, label: 'End-to-End Staffing Solutions'
    },
    { icon: assets.abouticon2, label: 'Cost-Effective Services' },
    { icon: assets.abouticon3, label: '24/7 Service' },
  ]

  return (
    <section id={id} className='w-full scroll-mt-32'>
      <CommonBanner backgroundImage={assets.banner} title='About Us' subheading='Home/ About Us' />
      <section className="max-w-[1400px] mx-auto px-6 xl:pt-20 pt-14 grid grid-cols-1 lg:grid-cols-2 xl:gap-16 gap-10 items-start">

        <div data-aos="fade-up-right" data-aos-duration="1000" className="space-y-6 font-SpaceGrotesk">

          <LabelHeading label={'About Us'} heading={'About Natio Infotech Pvt Ltd - IT Hub'} position={'left'} />

          <p className="text-primaryTextColor font-DmSans leading-relaxed">
            We understand that attracting, qualifying, placing, and retaining the best
            candidates for our clients requires exceptional talent.
          </p>

          <p className="text-secondaryTextColor text-justify lg:text-left font-DmSans leading-relaxed">
            That’s why the highly skilled and dedicated recruitment team at Natio Infotech Pvt Ltd works tirelessly to build long-term
            relationships with both candidates and clients. We focus on helping our
            employees achieve their career goals while delivering effective staffing
            solutions tailored to the needs of our clients and candidates.
          </p>

          <div className="pt-4 flex flex-wrap lg:flex-nowrap gap-10">
            {labelData.map((item, index) => (
              <div key={index} className="flex flex-col space-y-2 w-[150px]">
                <img src={item.icon} alt={item.label} className="h-10 w-10" />
                <p className="text-primaryNavyTextColor text-[14px] font-medium font-KumbhSans">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000" className="relative w-full flex justify-center">

          <img
            src={assets.aboutimage}
            alt="About Natio"
            className="rounded-lg shadow-xl h-[25rem] md:h-[30rem] w-full object-cover"
          />

          <div className="absolute text-3xl flex flex-col items-center md:items-start text-center md:text-left md:text-4xl space-y-2 font-SpaceGrotesk bottom-0 right-0 bg-gradient-to-b from-primaryFadedColor to-primaryNavyTextColor text-white p-4 md:p-6 rounded-tl-3xl rounded-br-lg w-[50%] md:w-[40%]">
            <img src={assets.abouticon} alt="abouticon" className="h-14 md:h-16 w-14 md:w-16" />
            <div>
              <h3 className="font-bold">100+</h3>
              <p className="text-xl md:text-2xl opacity-90 font-light">Happy Customers</p>
            </div>
          </div>

        </div>
      </section>
    </section>
  )
}

export default AboutHero